import React from "react";
import UpdateUser from "../../../../components/Auth/UpdateUser";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ManageUserAccess = () => {
    const paramData = useParams();
    const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Module Access</h3>
            <button
                type="button"
                className="btn btn-secondary"
                style={{ maxHeight: "40px" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Back
              </button>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="">
            <UpdateUser staffId={paramData?.id} staffData={location?.state||{}}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageUserAccess;
